module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loginadmin/loginadmin.component.css
// module id = ./src/app/components/loginadmin/loginadmin.component.css
// module chunks = main